import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  FormControl,
  TextField,
  Button,
  Slider,
  Select,
  MenuItem,
} from "@mui/material";
import { useMediaQuery, useTheme } from '@mui/material';

const FilterModal = ({ open, onClose, setFilteredProducts }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
   const theme = useTheme();
            const isDesktop = useMediaQuery(theme.breakpoints.up('md')); 
  const [filters, setFilters] = useState({
    categoryName: "",
    location: "",
    priceRange: [1000, 10000],
  });

  // Fetch products once when component mounts
  useEffect(() => {
    fetch("https://daradservice.azurewebsites.net/api/P2PProducts/get-all-products", {
      headers: { Accept: "text/plain" },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          setProducts(data.data);
        }
      })
      .catch((error) => console.error("Error fetching products:", error));
  }, []); 

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handlePriceChange = (event, newValue) => {
    setFilters((prevFilters) => ({ ...prevFilters, priceRange: newValue }));
  };
  

  const applyFilters = () => {
    console.log("Applying filters:", filters);
  
    // Filtering is done on the parent component’s `products`
    const filtered = products.filter((product) => {
      return (
        (!filters.categoryName || product.categoryName?.toLowerCase() === filters.categoryName.toLowerCase()) &&
        (!filters.location || product.location?.toLowerCase().includes(filters.location.toLowerCase())) &&
        (!filters.priceRange || 
          (product.price >= filters.priceRange[0] && product.price <= filters.priceRange[1]))
      );
    });

    setFilteredProducts(filtered);
    onClose();
  };
  

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch("https://daradservice.azurewebsites.net/api/P2PProducts/categories", {
          headers: { accept: "application/json" }
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const result = await response.json();
        console.log("API Response:", result); 
  
        if (result.status && Array.isArray(result.data)) {
          setCategories(result.data);
          console.log("Fetched Categories:", result.data);
        } else {
          console.error("Unexpected API response format:", result);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
  
    fetchCategories();
  }, []);
  

  return (
    <Modal open={open} onClose={onClose}>
    <Box
  sx={{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isDesktop ? 550 : "90%",
    height: isDesktop ? 600 : "auto",
    bgcolor: "white",
    boxShadow: 24,
    p: isDesktop ? 5 : 3,
    borderRadius: "12px",
    textAlign: "left",
    mb: 2,
  }}
>

        <Typography variant="h6" mb={1} fontWeight="bold">Filter Products</Typography>
        <Typography sx={{ color: "#121212CC", mb: 2, fontSize: 14 }}>
          Refine your search to find exactly what you need—filter by category, location, and price in just a few clicks.
        </Typography>

        {/* Category Filter */}
        <Box sx={{ mt: 2, textAlign: "left" }}>
                <Typography variant="body2" fontWeight={500}>
                  Categories
                </Typography>
                <FormControl fullWidth sx={{ mt: 2 }}>
                <Select
  fullWidth
  value={filters.categoryName || ""}
  onChange={(e) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      categoryName: e.target.value, 
    }));
  }}
>
  <MenuItem value="">All Categories</MenuItem>
  {categories.map((category) => (
    <MenuItem key={category.id} value={category.name}>
      {category.name}
    </MenuItem>
  ))}
</Select>

                </FormControl>
              </Box>

        {/* Location Filter */}
        <Typography align="left" gutterBottom fontWeight="bold" mt={2}>Location</Typography>
        <TextField
          label="Enter a location"
          name="location"
          fullWidth
          variant="outlined"
          value={filters.location}
          onChange={handleFilterChange}
          sx={{ mb: 2 }}
        />

        {/* Price Range Filter */}
        <Typography sx={{ color: "black", mt: 4, fontWeight: "bold" }}>Price Range</Typography>
        <Typography sx={{ color: "#B6B6B6", mb: 2, fontSize: 14 }}>
          Set your price range (e.g., ₦1,000 - ₦10,000)
        </Typography>

        <Slider
  value={filters.priceRange}
  onChange={handlePriceChange}
  valueLabelDisplay="auto"
  min={500}
  max={1000000}
          sx={{ mb: 1, color: "#5604F6", backgroundColor: "#5604F6", padding: "4px 0" }}
        />

        {/* Buttons */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3, width: "100%", gap: 2 }}>
          <Button
            fullWidth
            sx={{
              mt: 3,
              width: "50%",
              borderRadius: "999px",
              backgroundColor: "#D3D3D3",
              color: "black",
              textTransform: "none",
              "&:hover": { backgroundColor: "#B0B0B0" }
            }}
            onClick={() => setFilters({ categoryName: "", location: "", priceRange: [1000, 10000] })}
          >
            Reset Filter
          </Button>
          <Button
            fullWidth
            sx={{
              mt: 3,
              width: "50%",
              borderRadius: "999px",
              backgroundColor: "#5604F6 !important",
              color: "#fff !important",
              textTransform: "none",
              "&:hover": { backgroundColor: "#4b00c2" },
            }}
            onClick={applyFilters}
          >
            Apply Filter
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FilterModal;
